module.exports = __webpack_public_path__ + "static/media/learning-1.6443b63c.png";